// 메뉴 아이콘 캐시 무효화 버전.
// 과거 블롭이 잘못된 Content-Type 으로 서빙되어 브라우저가 깨진 응답을 휴리스틱 캐시했다.
// 블롭은 고쳤지만 사용자 캐시가 남아 있으므로 쿼리로 우회한다. 아이콘을 바꾸면 값을 올린다.
export const MENU_ICON_VERSION = '20261002';

/**
 * 원격(http/https) 메뉴 아이콘 URL 에만 버전 쿼리를 붙인다.
 * 번들 자산(require)·data: URL·빈 값은 그대로 반환한다.
 */
export function withIconVersion(url) {
  if (typeof url !== 'string' || !/^https?:\/\//i.test(url)) return url;
  if (/[?&]v=/.test(url)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}v=${MENU_ICON_VERSION}`;
}
